export enum ActionEnum {
  Created = "created",
  Updated = "updated",
  Deleted = "deleted",
}
